import Select from "react-select";
import ReactMultiSelect from "../../../components/global/ReactMultiSelect";
import React, {useEffect, useRef, useState} from "react";
import {FilterIcon} from "../../../AppIcons";
import Constants from "../../../Constants";
import {getAxiosResponse, handleError} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import {useTranslation} from "react-i18next";
import "../../../assets/sass/layout/_filters.scss";
import $ from "jquery";
import {isEqualOrBlank} from "../../../services/Util";


export default function Filters({
                                    selectedDepartment,
                                    filterTypes,
                                    submitJsonCallback,
                                    submitQueryParamsCallback,
                                    defaultValues,
                                }) {
    const {t} = useTranslation();
    const [displayFilter, setDisplayFilter] = useState(false);
    const translate = t;

    const toggleButtonRef = useRef(null);
    const popupRef = useRef(null);

    const [projectStatusList, setProjectStatusList] = useState([]);
    const [deliveryStatusList, setDeliveryStatusList] = useState([]);
    const [invoiceStatusList, setInvoiceStatusList] = useState([]);
    const [currencyList, setCurrencyList] = useState([])
    const [sourceLanguageList, setSourceLanguageList] = useState([]);
    const [targetLanguageList, setTargetLanguageList] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [reviewersList, setReviewersList] = useState([]);
    const [workflowList, setWorkflowList] = useState([]);
    const [tagList, setTagList] = useState([]);
    const [intendedUseList, setIntendedUseList] = useState([]);
    const [campaignList, setCampaignList] = useState([]);
    const [workflows, setWorkflows] = useState([]);
    const [editTypeList, setEditTypeList] = useState([]);

    const [selectedProjectStatus, setSelectedProjectStatus] = useState([]);
    const [selectedDeliveryStatus, setSelectedDeliveryStatus] = useState([]);
    const [selectedInvoiceStatus, setSelectedInvoiceStatus] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(Constants.USD);
    const [selectedSourceLanguage, setSelectedSourceLanguage] = useState(null);
    const [selectedTargetLanguages, setSelectedTargetLanguages] = useState([]);
    const [selectedVendors, setSelectedVendors] = useState([]);
    const [selectedReviewers, setSelectedReviewers] = useState([]);
    const [selectedWorkflows, setSelectedWorkflows] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);
    const [selectedIntendedUse, setSelectedIntendedUse] = useState([]);
    const [selectedCampaign, setSelectedCampaign] = useState([]);
    const [selectedProjectByWorkflow, setSelectedProjectByWorkflow] = useState([]);
    const [selectedEditType, setSelectedEditType] = useState(null);

    const projectStatusSelectRef = useRef(null)
    const deliveryStatusSelectRef = useRef(null)
    const invoiceStatusSelectRef = useRef(null)
    const targetLangSelectRef = useRef(null)
    const vendorSelectRef = useRef(null)
    const reviewersSelectRef = useRef(null)
    const workflowsSelectRef = useRef(null)
    const tagsSelectRef = useRef(null)
    const intendedUsesSelectRef = useRef(null)
    const campaignSelectRef = useRef(null)

    const [defaultFilterValues, setDefaultFilterValues] = useState({});
    const [defaultFilterProcessingCounter, setDefaultFilterProcessingCounter] = useState(0);

    const multiSelectBlankOptions = [
        {
            label: translate("task_campaign.check_all"),
            value: "all",
        }, {
            label: translate("task_campaign.uncheck_all"),
            value: "none",
        }
    ];

    const selectBlankOption = [{label: Constants.SELECT, value: Constants.BLANK}]


    const projectStatusOptions = [
        {
            value: "ALL_BIDS_REJECTED",
            label: translate("report.project_dashboard.project_status.projectStatusAllBidsRejected")
        },
        {
            value: "ALL_TRANSLATION_APPROVED",
            label: translate("report.project_dashboard.project_status.projectStatusAllTranslationApproved")
        },
        {
            value: "BID_SELECTION_EXPIRED",
            label: translate("report.project_dashboard.project_status.projectStatusBidSelectionExpired")
        },
        {
            value: "CHANGE_ORDER_REQUESTED",
            label: translate("report.project_dashboard.project_status.projectStatusChangeOrderRequested")
        },
        {value: "IN_CREATION", label: translate("report.project_dashboard.project_status.projectStatusInCreation")},
        {value: "IN_REVIEW", label: translate("report.project_dashboard.project_status.projectStatusInReview")},
        {
            value: "IN_TRANSLATION",
            label: translate("report.project_dashboard.project_status.projectStatusInTranslation")
        },
        {
            value: "IN_CANCELLATION",
            label: translate("report.project_dashboard.project_status.projectStatusInCancellation")
        },
        {
            value: "SUBMITTED_FOR_BIDS",
            label: translate("report.project_dashboard.project_status.projectStatusSubmittedForBids")
        },
        {
            value: "WAITING_FOR_CUSTOMER_BID_SELECTION",
            label: translate("report.project_dashboard.project_status.projectStatusWaitingForBidSelection")
        },
        {value: "PROJECT_CLOSED", label: translate("report.project_dashboard.project_status.projectStatusClosed")}
    ];

    const deliveryStatusOptions = [
        {label: "On Track", value: "ON_TRACK"},
        {label: "At Risk", value: "AT_RISK"},
        {label: "Late", value: "LATE"},
        {label: "Cancelled", value: "CANCELLED"},
        {label: "Completed", value: "COMPLETED"},
    ]

    const invoiceOptions = [
        {value: "CUSTOMER_INVOICE_NO_ACTION", label: "Invoice not sent"},
        {value: "CUSTOMER_INVOICE_SENT", label: "Invoice sent"},
        {value: "CUSTOMER_INVOICE_PAID", label: "Invoice paid"},
    ]

    const editTypeOptions = [
        {label: translate("report.project_dashboard.edit_type.ALL"), value: "ALL"},
        {label: translate("report.project_dashboard.edit_type.FEEDBACK"), value: "FEEDBACK"},
        {label: translate("report.project_dashboard.edit_type.EDITS"), value: "EDITS"}
    ]

    useEffect(() => {
        initFilters();
    }, [])

    useEffect(() => {
        if (defaultFilterProcessingCounter >= filterTypes.length) {
            applyFilters();
            setDefaultFilterProcessingCounter(0);
        }
    }, [defaultFilterProcessingCounter]);

    useEffect(() => {
        setDefaultValue(FilterType.PROJECT_STATUS)
        setDefaultFilterProcessingCounter(i => i + 1)
    }, [projectStatusList])

    useEffect(() => {
        setDefaultValue(FilterType.DELIVERY_STATUS)
        setDefaultFilterProcessingCounter(i => i + 1)
    }, [deliveryStatusList])

    useEffect(() => {
        setDefaultValue(FilterType.INVOICE_STATUS)
        setDefaultFilterProcessingCounter(i => i + 1)
    }, [invoiceStatusList])

    useEffect(() => {
        setDefaultValue(FilterType.CURRENCY)
        setDefaultFilterProcessingCounter(i => i + 1)
    }, [currencyList])

    useEffect(() => {
        setDefaultValue(FilterType.SOURCE_LANGUAGE)
        setDefaultFilterProcessingCounter(i => i + 1)
    }, [sourceLanguageList])

    useEffect(() => {
        setDefaultValue(FilterType.TARGET_LANGUAGES)
        setDefaultFilterProcessingCounter(i => i + 1)
    }, [targetLanguageList])

    useEffect(() => {
        setDefaultValue(FilterType.VENDORS)
        setDefaultFilterProcessingCounter(i => i + 1)
    }, [vendorList])

    useEffect(() => {
        setDefaultValue(FilterType.REVIEWERS)
        setDefaultFilterProcessingCounter(i => i + 1)
    }, [reviewersList])

    useEffect(() => {
        setDefaultValue(FilterType.WORKFLOWS)
        setDefaultFilterProcessingCounter(i => i + 1)
    }, [workflowList])

    useEffect(() => {
        setDefaultValue(FilterType.TAGS)
        setDefaultFilterProcessingCounter(i => i + 1)
    }, [tagList])

    useEffect(() => {
        setDefaultValue(FilterType.INTENDED_USE)
        setDefaultFilterProcessingCounter(i => i + 1)
    }, [intendedUseList])

    useEffect(() => {
        setDefaultValue(FilterType.CAMPAIGNS)
        setDefaultFilterProcessingCounter(i => i + 1)
    }, [campaignList])

    useEffect(() => {
        setDefaultValue(FilterType.PROJECT_BY_WORKFLOW)
        setDefaultFilterProcessingCounter(i => i + 1)
    }, [workflows])

    useEffect(() => {
        setDefaultValue(FilterType.EDIT_TYPE)
        setDefaultFilterProcessingCounter(i => i + 1)
    }, [editTypeList])

    useEffect(() => {
        if (displayFilter) {
            document.addEventListener("keydown", handleEscapeKey);
        } else {
            document.removeEventListener("keydown", handleEscapeKey);
        }
        return () => {
            document.removeEventListener("keydown", handleEscapeKey);
        };
    }, [displayFilter]);


    const handleEscapeKey = (event) => {
        if (event.key === Constants.ESCAPE) {
            setDisplayFilter(false);
            toggleButtonRef.current?.focus();
        }
    }

    function initFilters() {
        filterTypes.forEach(type => {
            switch (type) {
                case FilterType.PROJECT_STATUS:
                    setProjectStatusList([...multiSelectBlankOptions, ...(sortOptions(projectStatusOptions))]);
                    break;
                case FilterType.DELIVERY_STATUS:
                    setDeliveryStatusList([...multiSelectBlankOptions, ...(sortOptions(deliveryStatusOptions))]);
                    break;
                case FilterType.INVOICE_STATUS:
                    setInvoiceStatusList([...multiSelectBlankOptions, ...(sortOptions(invoiceOptions))]);
                    break;
                case FilterType.CURRENCY:
                    loadList(APIUrls.PROJECT_CURRENCIES, setCurrencyList, null,
                        ({code, label}) => ({
                            label: label,
                            value: code
                        }))
                    break;
                case FilterType.SOURCE_LANGUAGE:
                    loadList(APIUrls.SOURCE_LANGUAGE, setSourceLanguageList, selectBlankOption,
                        ({language, display}) => ({
                            label: display,
                            value: language
                        }))
                    break;
                case FilterType.TARGET_LANGUAGES:
                    loadList(APIUrls.TARGET_LANGUAGE, setTargetLanguageList, multiSelectBlankOptions,
                        ({language, display}) => ({
                            label: display,
                            value: language
                        }))
                    break;
                case FilterType.VENDORS:
                    loadList(APIUrls.ALL_VENDORS, setVendorList, multiSelectBlankOptions,
                        ({id, name, isInternal}) => ({
                            label: name,
                            value: id * (isInternal ? -1 : 1)
                        }))
                    break;
                case FilterType.REVIEWERS:
                    loadList(APIUrls.PROJECT_LISTING_PROJECT_OWNERS, setReviewersList, multiSelectBlankOptions,
                        ({userId, firstName, lastName}) => ({
                            label: `${firstName ? firstName : ""} ${lastName ? lastName : ""}`,
                            value: userId
                        }))
                    break;
                case FilterType.WORKFLOWS:
                    loadList(APIUrls.WORKFLOWS, setWorkflowList, multiSelectBlankOptions,
                        ({id, name}) => ({
                            label: name,
                            value: name
                        }))
                    break;
                case FilterType.PROJECT_BY_WORKFLOW:
                    loadList(APIUrls.WORKFLOWS, setWorkflows, null,
                        ({id, name}) => ({
                            label: name,
                            value: name
                        }))
                    break;
                case FilterType.TAGS:
                    loadList(APIUrls.PROJECT_LISTING_TAGS, setTagList, multiSelectBlankOptions,
                        ({id, display}) => ({
                            label: display,
                            value: id
                        }), (res) => res.data.data.result)
                    break;
                case FilterType.INTENDED_USE:
                    loadList(APIUrls.INTENDED_USES_TASKS, setIntendedUseList, multiSelectBlankOptions,
                        ({id, name}) => ({
                            label: name,
                            value: id
                        }))
                    break;
                case FilterType.CAMPAIGNS:
                    loadList(APIUrls.PROJECT_LISTING_WORKSPACES, setCampaignList, multiSelectBlankOptions,
                        ({id, name}) => ({
                            label: name,
                            value: id
                        }))
                    break;
                case FilterType.EDIT_TYPE:
                    setEditTypeList(editTypeOptions);
                default:
                    break;
            }
        })
    }

    const isEmpty = (list) => {
        if (list) {
            return list.filter(option => ["all", "none", Constants.BLANK].indexOf(option.value) === -1).length === 0
        }
        return true;
    }
    const sortOptions = (options) => {
        return options.sort((a, b) => a.label.toLowerCase().trim().localeCompare(b.label.toLowerCase().trim()));
    }


    const loadList = (url, setter, blankOptions, transformer, getList) => {
        getAxiosResponse(url)
            .then((res) => {
                if (res.data.code === 200) {
                    let options = [];
                    if (blankOptions) {
                        options = [...blankOptions]
                    }
                    let list = getList ? getList(res) : res.data.data;
                    if (transformer) {
                        list = list.map(transformer);
                        list = sortOptions(list);
                        options = [...options, ...list];
                    }
                    if (setter) {
                        setter(options)
                    }
                }
            })
            .catch((err) => {
                handleError(err);
            });
    }

    const filterToggle = (e) => {
        // close other filters:
        let buttons = $(".filterToggle")
        let $target = $(e.target).closest(".filterToggle")
        for (let i = 0; i < buttons.length; i++) {
            let button = buttons[i];
            if (!$target.is(button)) {
                $(button).closest(".filter").find(".hideButton").click();
            }
        }

        setDisplayFilter(v => !v);
    };

    const handleModalFocus = (event) => {
        if (event.key === Constants.ESCAPE && event.target.ariaExpanded === 'false') {
            setDisplayFilter(false);
            toggleButtonRef.current.focus();
        }
        if (event.target.ariaLabel === 'Language') {
            event.preventDefault();
            setDisplayFilter(false);
            toggleButtonRef.current.focus();
        }
    }

    const handleMultiSelectInputChange = (e) => {
        // multi select has a mandatory callback requirement
    }

    const getProjectStatusComponent = () => {
        return <div
            className={"global-dropdown-block global-multidropdown-check flex-center " + (isEmpty(projectStatusList) ? "hide" : "")}>
            <div className="global-dropdown-select">
                <label>
                    Project Status
                </label>
                <ReactMultiSelect
                    ref={projectStatusSelectRef}
                    value={selectedProjectStatus}
                    option={projectStatusList}
                    callback={setSelectedProjectStatus}
                    ariaLabel={'Project Status'}
                    placeholder={'Select '}
                    inputChange={handleMultiSelectInputChange}/>
            </div>
        </div>
    }

    const getDeliveryStatusComponent = () => {
        return <div
            className={"global-dropdown-block global-multidropdown-check flex-center " + (isEmpty(deliveryStatusList) ? "hide" : "")}>
            <div className="global-dropdown-select">
                <label>
                    Delivery Status
                </label>
                <ReactMultiSelect
                    ref={deliveryStatusSelectRef}
                    value={selectedDeliveryStatus}
                    option={deliveryStatusList}
                    callback={setSelectedDeliveryStatus}
                    ariaLabel={'Delivery Status'}
                    placeholder={'Select '}
                    inputChange={handleMultiSelectInputChange}/>
            </div>
        </div>
    }

    const getInvoiceStatusComponent = () => {
        return <div
            className={"global-dropdown-block global-multidropdown-check flex-center " + (isEmpty(invoiceStatusList) ? "hide" : "")}>
            <div className="global-dropdown-select">
                <label>
                    Invoice Status
                </label>
                <ReactMultiSelect
                    ref={invoiceStatusSelectRef}
                    value={selectedInvoiceStatus}
                    option={invoiceStatusList}
                    callback={setSelectedInvoiceStatus}
                    ariaLabel={'Invoice Status'}
                    placeholder={'Select '}
                    inputChange={handleMultiSelectInputChange}/>
            </div>
        </div>
    }

    const getCurrencyComponent = () => {
        return <div className={"global-dropdown-block flex-center" + (isEmpty(currencyList) ? "hide" : "")}>
            <div className="global-dropdown-select">
                <label>Currency</label>
                <Select className="global-dropdown-select"
                        classNamePrefix="cw"
                        value={selectedCurrency}
                        aria-label="Type"
                        options={currencyList}
                        onChange={setSelectedCurrency}/>
            </div>
        </div>
    }

    const getSourceLanguageComponent = () => {
        return <div className={"global-dropdown-block flex-center" + (isEmpty(sourceLanguageList) ? "hide" : "")}>
            <div className="global-dropdown-select">
                <label>
                    Source Language
                </label>
                <Select className="global-dropdown-select"
                        classNamePrefix="cw"
                        value={selectedSourceLanguage}
                        aria-label="Type"
                        options={sourceLanguageList}
                        onChange={setSelectedSourceLanguage}/>
            </div>
        </div>
    }

    const getTargetLanguageComponent = () => {
        return <div
            className={"global-dropdown-block global-multidropdown-check flex-center " + (isEmpty(targetLanguageList) ? "hide" : "")}>
            <div className="global-dropdown-select">
                <label>
                    Target Languages
                </label>
                <ReactMultiSelect
                    ref={targetLangSelectRef}
                    value={selectedTargetLanguages}
                    option={targetLanguageList}
                    callback={setSelectedTargetLanguages}
                    ariaLabel={'Target Language'}
                    placeholder={'Select '}
                    inputChange={handleMultiSelectInputChange}
                />
            </div>
        </div>
    }

    const getVendorsComponent = () => {
        return <div
            className={"global-dropdown-block global-multidropdown-check flex-center " + (isEmpty(vendorList) ? "hide" : "")}>
            <div className="global-dropdown-select">
                <label>
                    Vendors
                </label>
                <ReactMultiSelect
                    ref={vendorSelectRef}
                    value={selectedVendors}
                    option={vendorList}
                    callback={setSelectedVendors}
                    ariaLabel={'Vendors'}
                    placeholder={'Select '}
                    inputChange={handleMultiSelectInputChange}/>
            </div>
        </div>
    }

    const getReviewersComponent = () => {
        return <div
            className={"global-dropdown-block global-multidropdown-check flex-center " + (isEmpty(reviewersList) ? "hide" : "")}>
            <div className="global-dropdown-select">
                <label>
                    Project Owners
                </label>
                <ReactMultiSelect
                    ref={reviewersSelectRef}
                    value={selectedReviewers}
                    option={reviewersList}
                    callback={setSelectedReviewers}
                    ariaLabel={'Reviewers'}
                    placeholder={'Select '}
                    inputChange={handleMultiSelectInputChange}/>
            </div>
        </div>
    }

    const getWorkflowsComponent = () => {
        return <div
            className={"global-dropdown-block global-multidropdown-check flex-center " + (isEmpty(workflowList) ? "hide" : "")}>
            <div className="global-dropdown-select">
                <label>
                    Workflows
                </label>
                <ReactMultiSelect
                    ref={workflowsSelectRef}
                    value={selectedWorkflows}
                    option={workflowList}
                    callback={setSelectedWorkflows}
                    ariaLabel={'Workflows'}
                    placeholder={'Select '}
                    inputChange={handleMultiSelectInputChange}/>
            </div>
        </div>
    }

    const getProjectByWorkflowComponent = () => {
        return <div className={"global-dropdown-block flex-center" + (isEmpty(workflows) ? "hide" : "")}>
            <div className="global-dropdown-select">
                <label>
                    Workflows
                </label>
                <Select className="global-dropdown-select"
                        classNamePrefix="cw"
                        value={selectedProjectByWorkflow}
                        aria-label="Workflows"
                        options={workflows}
                        onChange={setSelectedProjectByWorkflow}/>
            </div>
        </div>
    }

    const getTagsComponent = () => {
        return <div
            className={"global-dropdown-block global-multidropdown-check flex-center " + (isEmpty(tagList) ? "hide" : "")}>
            <div className="global-dropdown-select">
                <label>
                    Tags
                </label>
                <ReactMultiSelect
                    ref={tagsSelectRef}
                    value={selectedTags}
                    option={tagList}
                    callback={setSelectedTags}
                    ariaLabel={'Tags'}
                    placeholder={'Select '}
                    inputChange={handleMultiSelectInputChange}/>
            </div>
        </div>
    }

    const getIntendedUsesComponent = () => {
        return <div
            className={"global-dropdown-block global-multidropdown-check flex-center " + (isEmpty(intendedUseList) ? "hide" : "")}>
            <div className="global-dropdown-select">
                <label>
                    Intended Uses
                </label>
                <ReactMultiSelect
                    ref={intendedUsesSelectRef}
                    value={selectedIntendedUse}
                    option={intendedUseList}
                    callback={setSelectedIntendedUse}
                    ariaLabel={'Intended Uses'}
                    placeholder={'Select '}
                    inputChange={handleMultiSelectInputChange}/>
            </div>
        </div>
    }

    const getCampaignsComponent = () => {
        return <div
            className={"global-dropdown-block global-multidropdown-check flex-center" + (isEmpty(campaignList) ? "hide" : "")}>
            <div className="global-dropdown-select">
                <label>
                    Campaigns
                </label>

                <ReactMultiSelect
                    ref={campaignSelectRef}
                    value={selectedCampaign}
                    option={campaignList}
                    callback={setSelectedCampaign}
                    ariaLabel={'Campaigns'}
                    placeholder={'Select '}
                    inputChange={handleMultiSelectInputChange}/>
            </div>
        </div>
    }

    const getEditTypeComponent = () => {
        return <div className={"global-dropdown-block flex-center" + (isEmpty(editTypeList) ? "hide" : "")}>
            <div className="global-dropdown-select">
                <label>
                    Edit Type
                </label>
                <Select className="global-dropdown-select"
                        classNamePrefix="cw"
                        value={selectedEditType}
                        aria-label="Edit Type"
                        options={editTypeList}
                        onChange={setSelectedEditType}/>
            </div>
        </div>
    }


    const getFilterComponents = () => {
        if (!filterTypes) return "";
        return filterTypes.map((type) => {
            switch (type) {
                case FilterType.PROJECT_STATUS:
                    return getProjectStatusComponent();
                case FilterType.DELIVERY_STATUS:
                    return getDeliveryStatusComponent();
                case FilterType.INVOICE_STATUS:
                    return getInvoiceStatusComponent();
                case FilterType.CURRENCY:
                    return getCurrencyComponent();
                case FilterType.SOURCE_LANGUAGE:
                    return getSourceLanguageComponent();
                case FilterType.TARGET_LANGUAGES:
                    return getTargetLanguageComponent();
                case FilterType.VENDORS:
                    return getVendorsComponent();
                case FilterType.REVIEWERS:
                    return getReviewersComponent();
                case FilterType.WORKFLOWS:
                    return getWorkflowsComponent();
                case FilterType.PROJECT_BY_WORKFLOW:
                    return getProjectByWorkflowComponent();
                case FilterType.TAGS:
                    return getTagsComponent();
                case FilterType.INTENDED_USE:
                    return getIntendedUsesComponent();
                case FilterType.CAMPAIGNS:
                    return getCampaignsComponent();
                case FilterType.EDIT_TYPE:
                    return getEditTypeComponent();
                default:
                    return "";
            }
        })
    }

    const getFilterValue = (type) => {
        switch (type) {
            case FilterType.PROJECT_STATUS:
                return selectedProjectStatus;
            case FilterType.DELIVERY_STATUS:
                return selectedDeliveryStatus;
            case FilterType.INVOICE_STATUS:
                return selectedInvoiceStatus;
            case FilterType.CURRENCY:
                return selectedCurrency;
            case FilterType.SOURCE_LANGUAGE:
                return selectedSourceLanguage;
            case FilterType.TARGET_LANGUAGES:
                return selectedTargetLanguages;
            case FilterType.VENDORS:
                return selectedVendors;
            case FilterType.REVIEWERS:
                return selectedReviewers;
            case FilterType.WORKFLOWS:
                return selectedWorkflows;
            case FilterType.PROJECT_BY_WORKFLOW:
                return selectedProjectByWorkflow;
            case FilterType.TAGS:
                return selectedTags;
            case FilterType.INTENDED_USE:
                return selectedIntendedUse;
            case FilterType.CAMPAIGNS:
                return selectedCampaign;
            case FilterType.EDIT_TYPE:
                return selectedEditType;
            default:
                return null;
        }
    }

    const getFilterList = (type) => {
        switch (type) {
            case FilterType.PROJECT_STATUS:
                return projectStatusList;
            case FilterType.DELIVERY_STATUS:
                return deliveryStatusList;
            case FilterType.INVOICE_STATUS:
                return invoiceStatusList;
            case FilterType.CURRENCY:
                return currencyList;
            case FilterType.SOURCE_LANGUAGE:
                return sourceLanguageList;
            case FilterType.TARGET_LANGUAGES:
                return targetLanguageList;
            case FilterType.VENDORS:
                return vendorList;
            case FilterType.REVIEWERS:
                return reviewersList;
            case FilterType.WORKFLOWS:
                return workflowList;
            case FilterType.PROJECT_BY_WORKFLOW:
                return workflows;
            case FilterType.TAGS:
                return tagList;
            case FilterType.INTENDED_USE:
                return intendedUseList;
            case FilterType.CAMPAIGNS:
                return campaignList;
            case FilterType.EDIT_TYPE:
                return editTypeList;
            default:
                return [];
        }
    }

    const getFilterSelectedSetter = (type) => {
        switch (type) {
            case FilterType.PROJECT_STATUS:
                return setSelectedProjectStatus;
            case FilterType.DELIVERY_STATUS:
                return setSelectedDeliveryStatus;
            case FilterType.INVOICE_STATUS:
                return setSelectedInvoiceStatus;
            case FilterType.CURRENCY:
                return setSelectedCurrency;
            case FilterType.SOURCE_LANGUAGE:
                return setSelectedSourceLanguage;
            case FilterType.TARGET_LANGUAGES:
                return setSelectedTargetLanguages;
            case FilterType.VENDORS:
                return setSelectedVendors;
            case FilterType.REVIEWERS:
                return setSelectedReviewers;
            case FilterType.WORKFLOWS:
                return setSelectedWorkflows;
            case FilterType.PROJECT_BY_WORKFLOW:
                return setSelectedProjectByWorkflow;
            case FilterType.TAGS:
                return setSelectedTags;
            case FilterType.INTENDED_USE:
                return setSelectedIntendedUse;
            case FilterType.CAMPAIGNS:
                return setSelectedCampaign;
            case FilterType.EDIT_TYPE:
                return setSelectedEditType;
            default:
                return null;
        }
    }

    const findOptions = (list, options) => {
        if (!list || !options) return null;
        if (options instanceof Array) {
            return options.map((option) => findOption(list, option));
        } else {
            return findOption(list, options)
        }
    }

    /*
    find option by:
        1. index (for selecting first in the list), first from the sorted list
        2. by value and/or label
     */
    const findOption = (list, option) => {
        if (option.hasOwnProperty("index")) {
            let filteredList = list.filter((option) => ["all", "none", ""].indexOf(option.value) === -1);
            if (filteredList.length >= option.index) {
                return filteredList[option.index];
            }
            return null;
        }
        return list.find(item =>
            (!option.hasOwnProperty("value") || option.value === item.value) &&
            (!option.hasOwnProperty("label") || option.label === item.label))
    }

    const setDefaultValues = () => {
        // this function also returns default value so that we can apply it automatically after resetting
        if (!filterTypes) return {};
        return filterTypes.reduce((result, type) => {
            result[type] = setDefaultValue(type)
            return result
        }, {})
    }

    const setDefaultValue = (filterType) => {
        let value = null;
        let setter = getFilterSelectedSetter(filterType)
        if (!setter) return value;
        if (defaultValues && defaultValues[filterType]) {
            let list = getFilterList(filterType)
            value = findOptions(list, defaultValues[filterType])
            if (value == null) {
                if (getFilterValue(filterType) instanceof Array) {
                    value = []
                }
            }
        } else {
            if (getFilterValue(filterType) instanceof Array) {
                value = []
            }
        }
        setDefaultFilterValues(val => {
            val[filterType] = value
            return val;
        });
        setter(value)
        return value
    }

    const getFilterMap = (selectedValues) => {
        if (!filterTypes) return {};
        return filterTypes.reduce((result, type) => {
            let val = selectedValues ? selectedValues[type] : getFilterValue(type);
            if (val) {
                if (typeof val === 'object' && !Array.isArray(val)) {
                    result[type] = val.value
                } else {
                    if (Array.isArray(val)) {
                        val = val.filter(i => i).map(v => v.value);
                    }
                    result[type] = val
                }
            }
            return result;
        }, {});
    }

    const applyFilterEvent = () => {
        applyFilters()
    }

    const applyFilters = (selectedValues) => {
        let filters = getFilterMap(selectedValues);
        submitFilters(filters);
    }

    const submitFilters = (filters) => {
        if (submitQueryParamsCallback) {
            submitQueryParamsCallback(getQueryParams(filters));
        }
        if (submitJsonCallback) {
            filters.isDefault = isDefaultValues(filters)
            submitJsonCallback(filters)
        }
        setDisplayFilter(false);
    }

    const getQueryParams = (params) => {
        if (!params) return "";
        return Object.entries(params).reduce((result, [key, value]) => {
            if (Array.isArray(value)) {
                return value.reduce((result, val) => {
                    return `${result ? result + "&" : result}${key}=${val}`
                }, result)
            } else {
                return `${result ? result + "&" : result}${key}=${value}`
            }
        }, "")
    }

    const resetFilters = () => {
        let filters = setDefaultValues()
        applyFilters(filters);
    }

    const isDefaultValues = (filters) => {
        return isEqualOrBlank(filters, getFilterMap(defaultFilterValues))
    }

    return <>
        <div className="filter-widget">
            <div className="campaign_details-task campaign-form task-page-form pt-0">
                <div className="btn-wrap">
                    <div className="filter mr-0" id="filter">
                        <button ref={toggleButtonRef} id="filterToggle"
                                className="filterToggle"
                                title="Filters"
                                onClick={filterToggle}>
                            {FilterIcon}
                        </button>
                        <button className="hide hideButton" onClick={e => setDisplayFilter(false)}></button>
                        <div id="filterBtn" ref={popupRef}
                             className="filter-content opaque flex local-filter"
                             style={{display: displayFilter ? "block" : "none"}}
                             onKeyDown={(e) => handleModalFocus(e)}>
                            <div className="flex wrap-dropdown popup-overlay">
                                {getFilterComponents()}
                            </div>
                            <div className="flex action-buttons">
                                <button id="reset" className="dashboard-btn" onClick={resetFilters}>
                                    Reset
                                </button>
                                <button id="apply" className="dashboard-btn active" onClick={applyFilterEvent}>
                                    Apply Filters
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}

export const FilterType = {
    PROJECT_STATUS: "projectStatusCodes",
    DELIVERY_STATUS: "deliveryStatus",
    INVOICE_STATUS: "billingStatus",
    CURRENCY: "currency",
    SOURCE_LANGUAGE: "srcLang",
    TARGET_LANGUAGES: "trgLangs",
    VENDORS: "vendors",
    REVIEWERS: "owners",
    WORKFLOWS: "projectWorkflows",
    PROJECT_BY_WORKFLOW: "projectByWorkflows",
    TAGS: "tagIds",
    INTENDED_USE: "intendedUseIds",
    CAMPAIGNS: "workspaceIds",
    EDIT_TYPE: "editType"
}